/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

const AvailableLocales = ['en', 'ja', 'ja-Hira'];

const Message = {
    webkitLang: {
        'ja': 'ja-JP',
        'ja-Hira': 'ja-JP',
        'en': 'en-US',
    },
    categoryName: {
        'ja': '翻訳',
        'ja-Hira': 'ほんやく',
        'en': 'Translation',
    },
    translate: {
        'ja': '[WORDS] を [LANGUAGE] に翻訳',
        'ja-Hira': '[WORDS] を [LANGUAGE] にほんやく',
        'en': 'translate [WORDS] to [LANGUAGE]',
    },
    modelStatus: {
        'ja': '翻訳モデルの状態',
        'ja-Hira': 'ほんやくモデルのじょうたい',
        'en': 'translation model status',
    },
    loadingMessage: {
        'ja': 'モデル読み込み中...約3分お待ちください',
        'ja-Hira': 'モデルよみこみちゅう...やく3ふんおまちください',
        'en': 'Loading model... Please wait about 3 minutes',
    },
    modelNotReady: {
        'ja': '未ロード',
        'ja-Hira': 'みロード',
        'en': 'Not loaded',
    },
    modelLoading: {
        'ja': '読み込み中',
        'ja-Hira': 'よみこみちゅう',
        'en': 'Loading',
    },
    modelReady: {
        'ja': '準備完了',
        'ja-Hira': 'じゅんびかんりょう',
        'en': 'Ready',
    },
    modelError: {
        'ja': 'エラー',
        'ja-Hira': 'エラー',
        'en': 'Error',
    },
    languageMenu: {
        english: {
            'ja': '英語',
            'ja-Hira': 'えいご',
            'en': 'English'
        },
        japanese: {
            'ja': '日本語',
            'ja-Hira': 'にほんご',
            'en': 'Japanese'
        },
        chinese: {
            'ja': '中国語',
            'ja-Hira': 'ちゅうごくご',
            'en': 'Chinese'
        },
        korean: {
            'ja': '韓国語',
            'ja-Hira': 'かんこくご',
            'en': 'Korean'
        },
        french: {
            'ja': 'フランス語',
            'ja-Hira': 'フランスご',
            'en': 'French'
        },
        spanish: {
            'ja': 'スペイン語',
            'ja-Hira': 'スペインご',
            'en': 'Spanish'
        },
        german: {
            'ja': 'ドイツ語',
            'ja-Hira': 'ドイツご',
            'en': 'German'
        }
    }
};

/**
 * NLLB-200モデルの言語コード
 * 各言語のNLLB-200形式のコードを定義
 */
const LanguageCodes = {
    'english': 'eng_Latn',
    'japanese': 'jpn_Jpan',
    'chinese': 'zho_Hans',
    'korean': 'kor_Hang',
    'french': 'fra_Latn',
    'spanish': 'spa_Latn',
    'german': 'deu_Latn'
};

module.exports = {
    AvailableLocales,
    Message,
    LanguageCodes
};